import { render, staticRenderFns } from "./CarsByFuel.vue?vue&type=template&id=6f1a0132&scoped=true&"
import script from "./CarsByFuel.vue?vue&type=script&lang=ts&"
export * from "./CarsByFuel.vue?vue&type=script&lang=ts&"
import style0 from "./CarsByFuel.vue?vue&type=style&index=0&id=6f1a0132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a0132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSpacer})
